import Base from './base'
import urls from 'config/urls'

class Customer extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.customer.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.customer.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.customer.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.customer.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.customer.delete,
      data: opts
    })
  }
}

export default new Customer



// WEBPACK FOOTER //
// ./src/models/customer.js